module.exports = __webpack_public_path__ + "static/media/c-pop-up-13.2e4e9c4c.png";